import { useState } from 'react'

import { GET_AD_UNIT } from 'features/inventory/api/queries/adUnit'
import { AdUnitData, AdUnitVars } from 'features/inventory/api/types/adUnit'
import { useFeatureFlag } from 'features/user/hooks/useFeatureFlag'
import { useAbility } from 'providers/casl'
import { DEFAULT_REFETCH_INTERVAL } from 'providers/tanstack-query/constants'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { adUnitForFormFromDTO } from './api/mappers/adUnitForForm'
import { AdUnitForForm, UseGetAdUnit, UseGetAdUnitProps } from './types'

export const useGetAdUnit = ({ id }: UseGetAdUnitProps): UseGetAdUnit => {
  const [adUnit, setAdUnit] = useState<AdUnitForForm>()
  const ability = useAbility()

  const { isFeatureEnabled: withControllingRefreshParamsOnAdUnitLevel } = useFeatureFlag(
    'yp2827ControlingRefreshParamsOnAdUnitLevel',
  )

  const { isLoading: loading } = useQuery<AdUnitVars, AdUnitData>({
    onCompleted: async data => {
      const { node: adUnit } = data

      if (adUnit) {
        setAdUnit(adUnitForFormFromDTO(adUnit))
      }
    },
    options: {
      enabled: id !== undefined,
      refetchInterval: DEFAULT_REFETCH_INTERVAL,
    },
    query: GET_AD_UNIT({ ability, withControllingRefreshParamsOnAdUnitLevel }),
    variables: { id: id! },
  })

  return { adUnit, loading }
}
